import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { NavContext } from "../../state/NavContext";
import { SideContext } from "../../state/SideContext";
import { Form, Typography, Button, Row, Col, message, Space } from "antd";
import axios from "axios";
import { UserContext } from "../../state/UserContext";

const { Title } = Typography;

const FormGame = (props) => {
  let { id } = useParams();
  const history = useHistory();

  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);
  const { setSideIndex } = useContext(SideContext);
  const { user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const [game, setGame] = useState({});

  useEffect(() => {
    setSideIndex(props.sideIndex === "add-game" ? "add-game" : "all-games");
    setActiveIndex("admin");
    setIsSideBarActive(true);
    setGame({
      genre: "",
      image_url: "",
      singlePlayer: 0,
      multiplayer: 0,
      name: "",
      platform: "",
      release: "",
    });
  }, [props.sideIndex, setActiveIndex, setIsSideBarActive, setSideIndex]);

  useEffect(() => {
    if (props.sideIndex === "edit-game" && id !== null) {
      // console.log(`loading data game`);
      // console.log(`game id: ${id}`);

      setIsLoading(true);

      axios
        .get(`https://backendexample.sanbersy.com/api/data-game/${id}`)
        .then((res) => {
          // console.log(res.data);

          setGame(res.data);

          // console.log(game, "game data loaded");
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          message.error({ content: "Failed to load game data" });
          console.log(err.response);
        });
    }
  }, []);

  const onFinish = () => {
    setIsLoading(true);
    const {
      genre,
      image_url,
      singlePlayer,
      multiplayer,
      name,
      platform,
      release,
    } = game;

    if (props.sideIndex === "add-game") {
      // console.log("add game");

      // console.log(game, "game add");
      axios
        .post(
          "https://backendexample.sanbersy.com/api/data-game",
          {
            genre,
            image_url,
            singlePlayer,
            multiplayer,
            name,
            platform,
            release,
          },
          {
            headers: { Authorization: "Bearer " + user.token },
          }
        )
        .then((res) => {
          setIsLoading(false);
          message.success({ content: "Success adding new game" });
          history.push("/admin/all-games");
        })
        .catch((err) => {
          setIsLoading(false);
          message.error({ content: "Failed adding game" });
          console.log(err.response);
        });
    } else {
      console.log("edit game");

      axios
        .put(
          `https://backendexample.sanbersy.com/api/data-game/${id}`,
          {
            genre,
            image_url,
            singlePlayer,
            multiplayer,
            name,
            platform,
            release,
          },
          {
            headers: { Authorization: "Bearer " + user.token },
          }
        )
        .then((res) => {
          setIsLoading(false);
          message.success({ content: "Success updating game" });
          history.push("/admin/all-games");
        })
        .catch((err) => {
          setIsLoading(false);
          message.error({ content: "Failed updating game" });
          console.log(err.response);
        });
    }
  };

  const onFinishFailed = (values) => {};

  const handleChange = (e) => {
    setGame({ ...game, [e.target.name]: e.target.value });
  };

  const handleRadioChange = (e) => {
    setGame({ ...game, [e.target.name]: parseInt(e.target.value) });
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          minHeight: 400,
          padding: 24,
          background: "white",
        }}
      >
        <Title level={2}>
          {props.sideIndex === "add-game" ? "Add Game" : "Edit Game"}
        </Title>
        <Form
          name="basic"
          layout="vertical"
          wrapperCol={{ span: 24 }}
          value={{ remember: false }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Name"
            rules={[{ required: true, message: "Please input game name!" }]}
          >
            <input
              className="ant-input"
              type="text"
              required
              placeholder="Input game name"
              name="name"
              value={game.name}
              onChange={handleChange}
            />
          </Form.Item>
          <Form.Item label="Platform">
            <input
              className="ant-input"
              type="text"
              required
              placeholder="Input game platform"
              name="platform"
              value={game.platform}
              onChange={handleChange}
            />
          </Form.Item>
          <Form.Item label="Genre">
            <input
              className="ant-input"
              type="text"
              required
              placeholder="Input game genre"
              name="genre"
              value={game.genre}
              onChange={handleChange}
            />
          </Form.Item>
          <Form.Item
            label="Release"
            rules={[
              { required: true, message: "Please input game release year!" },
            ]}
          >
            <div className="ant-input-number" style={{ width: "100%" }}>
              <div className="ant-input-number-input-wrap">
                <input
                  className="ant-input-number-input"
                  type="number"
                  required
                  placeholder="Input game release year"
                  name="release"
                  min="2000"
                  max="2021"
                  value={game.release}
                  onChange={handleChange}
                />
              </div>
            </div>
          </Form.Item>

          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Single Player">
                <Space>
                  <div>
                    <input
                      type="radio"
                      name="singlePlayer"
                      onChange={handleRadioChange}
                      value={1}
                      required
                      checked={game.singlePlayer === 1 ? true : false}
                    />{" "}
                    <label>Yes</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="singlePlayer"
                      onChange={handleRadioChange}
                      value={0}
                      required
                      checked={game.singlePlayer === 0 ? true : false}
                    />{" "}
                    <label>No</label>
                  </div>
                </Space>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Multi Player">
                <Space>
                  <div>
                    <input
                      type="radio"
                      name="multiplayer"
                      onChange={handleRadioChange}
                      value={1}
                      required
                      checked={game.multiplayer === 1 ? true : false}
                    />{" "}
                    <label>Yes</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="multiplayer"
                      onChange={handleRadioChange}
                      value={0}
                      required
                      checked={game.multiplayer === 0 ? true : false}
                    />{" "}
                    <label>No</label>
                  </div>
                </Space>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Image Url"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <input
              className="ant-input"
              type="text"
              required
              placeholder="Input game image url"
              name="image_url"
              value={game.image_url}
              onChange={handleChange}
            />
          </Form.Item>

          <Form.Item wrapperCol={{ span: 24 }}>
            <Button type="primary" htmlType="submit" block loading={isLoading}>
              {props.sideIndex === "add-game" ? "Add Game" : "Update Game"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default FormGame;
